<i18n>
{
  "cl": {
    "-": "-",
    "refused": "Rechazado",
    "approved": "Aprobado",
    "review": "Revisión",
    "with offer": "Propuesta",
    "without offer": "Sin oferta",
    "eligible": "Cumple",
    "not eligible": "No cumple"
  }
}
</i18n>
<template>
  <div>
    <section v-if="evaluation" id="resume">
      <div class="columns">
        <div class="column is-6">
          <div v-if="screenWidth <= 768">
            <FinancialInformationCard :read-only="true" />
            <CreditOfferCard :read-only="true" />
            <AssociatedInsuranceCard :read-only="true" />
            <GopsCard :read-only="true" />
            <LogsCard :evaluation="evaluation" />
          </div>
          <div v-else>
            <SimulationCard :read-only="true" />
            <PropertyCard :read-only="true" />
            <ParamsCard :read-only="true" />
          </div>
        </div>
        <div class="column is-6">
          <div class="columns is-1">
            <div class="column is-6-desktop">
              <div class="panel result">
                <div class="panel-block p-5 has-text-centered">
                  <p class="commercial-purpose">{{ commercialPurporse }}</p>
                  <small class="has-text-grey-light">{{ $t(getResult(evaluation.financingRatio, $getSafe(evaluation, 'approvedCreditAmount')).label) }}</small>
                </div>
              </div>
            </div>
            <div class="column is-6-desktop">
              <Policy :eligibility="evaluationEligibility" />
            </div>
          </div>
          <div v-if="isNotEmpty(evaluationExplanations)" class="explanations">
            <p class="has-text-weight-medium">La simulación no pudo ser pre-aprobada porque:</p>
            <ul class="fa-ul ml-5">
              <li v-for="(reason, key) in evaluationExplanations" :key="key">
                <span class="fa-li">
                  <i class="fas fa-circle-arrow-right fa-sm has-text-primary" />
                </span>
                {{ reason }}
              </li>
            </ul>
          </div>
          <div v-if="isNotEmpty(evaluationMessages)" class="messages mb-4">
            <p class="has-text-weight-medium">Gestiones a realizar:</p>
            <ul class="fa-ul ml-5">
              <li v-for="(message, key) in evaluationMessages" :key="key">
                <span class="fa-li">
                  <i class="fas fa-circle-arrow-right fa-sm has-text-primary" />
                </span>
                {{ message }}
              </li>
            </ul>
          </div>
          <div v-if="screenWidth <= 768">
            <SimulationCard :read-only="true" />
            <PropertyCard :read-only="true" />
            <ParamsCard :read-only="true" />
          </div>
          <div v-else>
            <FinancialInformationCard :read-only="true" />
            <CreditOfferCard :read-only="true" />
            <AssociatedInsuranceCard :read-only="true" />
            <GopsCard :read-only="true" />
            <LogsCard :evaluation="evaluation" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import SimulationCard from '@/ui/components/internal/evaluations/verify/SimulationCard.vue';
import PropertyCard from '@/ui/components/internal/evaluations/verify/PropertyCard.vue';
import ParamsCard from '@/ui/components/internal/evaluations/verify/ParamsCard.vue';
import GopsCard from '@/ui/components/internal/evaluations/verify/GopsCard.vue';
import AssociatedInsuranceCard from '@/ui/components/internal/evaluations/verify/AssociatedInsurance.vue';
import { formatNumberByCountry } from '@/infrastructure/format';
import Policy from '@/ui/components/internal/evaluations/verify/Policy.vue';
import FinancialInformationCard from '@/ui/components/internal/evaluations/verify/FinancialInformationCard.vue';
import CreditOfferCard from '@/ui/components/internal/evaluations/verify/CreditOfferCard.vue';
import LogsCard from '@/ui/components/internal/evaluations/verify/LogsCard.vue';
import { getResult } from '@/application/services/evaluations/evaluation-result-service';

export default {
  name: 'Resume',
  components: { Policy, PropertyCard, SimulationCard, ParamsCard, GopsCard, AssociatedInsuranceCard, FinancialInformationCard, CreditOfferCard, LogsCard },
  props: {
    evaluation: {
      type: Object
    }
  },
  data() {
    return {
      screenWidth: window.innerWidth
    };
  },
  computed: {
    commercialPurporse() {
      const value = this.$getSafe(this.evaluation, 'approvedCreditAmount');
      return value ? this.formatNumberByCountry(value) : 'UF 0';
    },
    evaluationEligibility() {
      return this.$getSafe(this.evaluation, 'eligibility.eligibility');
    },
    evaluationExplanations() {
      return this.$getSafe(this.evaluation, 'eligibility.explanations');
    },
    evaluationMessages() {
      return this.$getSafe(this.evaluation, 'eligibility.messages');
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods: {
    getResult,
    formatNumberByCountry(number, usePrefix = true, currencyType = 'primary') {
      if (number === null || number === undefined) {
        return 'UF 0';
      }
      return formatNumberByCountry({ number,
        countryIn: 'cl',
        usePrefix,
        currencyType });
    },
    isNotEmpty(value) {
      return value && value.length > 0;
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    }
  }
};
</script>
<style scoped>
h3{
  margin: 0 8px;
  display: inline-block;
  font-size: 1.25rem;
  font-weight: 500;
}
.panel{
  box-shadow: none;
}
.panel .panel-block{
  border: 1px solid #E9E9E9;
  border-radius: 10px;
}
#resume .panel.result {
  height: 100%;
}
#resume .panel .panel-block .commercial-purpose {
  font-size: 1.5rem;
  font-weight: 500;
}
#resume .approved {
  padding-bottom: 1.5rem;
}
#resume .explanations {
  padding-bottom: 1.5rem;
}
#resume .panel.result .panel-block{
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.collapse{
  margin-top: 1.5rem;
}
.collapse.simulation-card {
  margin-top: 0;
}
.collapse .panel-heading{
  margin-bottom: 0.1rem;
  background: transparent;
  padding: 0;
}
.collapse .panel-heading .collapse-icon{
  font-size: 0.8rem;
}
#resume .evaluation-card{
  box-shadow: none;
}
#resume .evaluation-card:last-child{
  margin-bottom: 0;
}

#resume ul.logs {
  list-style: disc;
  margin-left: 1rem;
}
@media screen and (max-width: 768px) {
  #resume .evaluation-card{
    margin: 1.25rem 0;
  }
  #resume > .columns{
    display: flex;
    flex-direction: column-reverse;
  }
  #resume > .columns > .column{
    padding-top: 0;
    padding-bottom: 0;
  }
}
@media screen and (min-width: 1024px) {
  .columns.is-desktop-reversed .column.is-8-desktop {
    order: -1;
  }
}
</style>
